import React from 'react';

const TagList = ({ 
  tags, 
  emptyMessage = 'N/A', 
  className = "tags", 
  tagClassName = "tag",
  emptyClassName = "na"
}) => {
  return (
    <div className={className}>
      {tags?.length > 0 ? (
        tags.map((tag, index) => (
          <span key={index} className={tagClassName}>{tag}</span>
        ))
      ) : (
        <span className={emptyClassName}>{emptyMessage}</span>
      )}
    </div>
  );
};

export default TagList;